export default {
  salesCounters: [],
  salesEmails: [],
  sitesSummaries: []
}
